import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  footer: {
    marginTop: 5,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerBoxExpiring: {
    width: 70,
    height: 14,
  },
  footerBoxNextScheduledPremier: {
    width: 60,
    height: 14,
  },
  footerBoxTotalWellnessCredits: {
    width: 55,
    height: 14,
  },
});
